import { Button, Form } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import Textarea from 'react-textarea-autosize';
var SendMessageForm = function (_a) {
    var _b;
    var forumChatId = _a.forumChatId, handleSubmit = _a.handleSubmit, isDisabled = _a.isDisabled, eventChat = _a.eventChat, isMobile = _a.isMobile, textValue = _a.textValue;
    var _c = useState(false), activatedButton = _c[0], setActivatedButton = _c[1];
    var form = Form.useForm()[0];
    useEffect(function () {
        if (textValue === '') {
            form.resetFields();
        }
    }, [textValue]);
    var onTextChange = useCallback(function (e) {
        if (e.currentTarget.value && e.currentTarget.value.trim().length && !activatedButton) {
            setActivatedButton(true);
        }
        else if ((!e.currentTarget.value || !e.currentTarget.value.trim().length) && activatedButton) {
            setActivatedButton(false);
        }
    }, [activatedButton]);
    var forum = forumChatId ? '-' + forumChatId : '';
    var handleKeyDown = useCallback(function (e) {
        if (e.key === 'Enter' && e.shiftKey === false) {
            e.preventDefault();
            handleSubmit(form.getFieldValue('text' + forum));
        }
    }, [form, forum, handleSubmit]);
    return (React.createElement(Form, { form: form, onFinish: function () { return handleSubmit(form.getFieldValue('text' + forum)); }, onKeyDown: handleKeyDown, className: "chat-form chat-message-form", id: "send-message-form", initialValues: (_b = {}, _b['text' + forum] = '', _b) },
        React.createElement(Form.Item, { name: 'text' + forum, className: "chat-input-item" },
            React.createElement(Textarea, { maxRows: 9, minRows: 1, onKeyUp: onTextChange, className: "chat-input content-messaging-textarea", "data-automation-id": "content-messaging-textarea", placeholder: "Write a message\u2026", disabled: isDisabled, style: { overflow: 'auto' } })),
        !eventChat || isMobile ? (React.createElement(Button, { htmlType: "submit", className: 'chat-sbm' + (activatedButton ? ' activated' : ''), id: 'button-send-message' + forum, "aria-label": "Send message" },
            React.createElement("svg", { className: "icon icon-send", xmlns: "http://www.w3.org/2000/svg", viewBox: "-1 -2 24 24", width: "32", height: "32", preserveAspectRatio: "xMinYMin", fill: "#ffffff" },
                React.createElement("path", { d: "M16.907 4.44l-7.655 7.655c.227.325.42.676.575 1.048l1.91 4.599 5.17-13.303zm-9.002 6.308l7.656-7.656-13.303 5.17 4.599 1.911a5.51 5.51 0 0 1 1.048.575zm11.618-7.862l-6.027 15.506c-.38.98-1.477 1.483-2.449 1.124a1.831 1.831 0 0 1-1.057-1.017L8.08 13.9a3.662 3.662 0 0 0-1.98-1.98l-4.6-1.91C.546 9.613.11 8.51.528 7.544a1.95 1.95 0 0 1 1.08-1.04L17.114.475a1.852 1.852 0 0 1 2.41 2.41z" })))) : null));
};
export default SendMessageForm;
